import React from 'react'
import { FiSearch, FiX } from 'react-icons/fi'

function SearchInput({ value, onChange, onClear }) {
  return (
    <div className='relative w-full bg-white dark:bg-dark-5 flex rounded-lg items-center'>
      <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
      <input
        type="text"
        placeholder="Rechercher une lessons..."
        value={value}
        onChange={onChange}
        className='w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg bg-white text-dark-1 focus:outline-none focus:ring-2 focus:ring-purple-1 focus:border-transparent'
      />
      {value && (
        <button
          onClick={onClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <FiX className="w-5 h-5" />
        </button>
      )}
    </div>
  )
}

export default SearchInput